import { Box, theme } from '@chakra-ui/react';
import React, { ChangeEvent, ReactNode, useCallback, useRef, useState } from 'react';
import { MdUploadFile } from 'react-icons/md';

import { Txt } from './text';

export type UploadProps = {
  label: ReactNode;
  disabled?: boolean;
  accept?: string;
  onChange?(objectUrl: string, file: File): void
}

export const Upload = ({
  label,
  disabled,
  accept,
  onChange,
}: UploadProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [selectedFile, setSelectedFile] = useState<File>();

  const onFileChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files || e.target.files.length === 0) {return;}
    const file = e.target.files[0];
    setSelectedFile(file);
    const objectUrl = URL.createObjectURL(file);
    onChange?.(objectUrl, file);
  }, [onChange]);
  
  return <Box __css={UploadWrapperStyles} >
    <MdUploadFile size={48} color={theme.colors.blue[500]} opacity={0.5} />
    {!selectedFile && label}
    {!!selectedFile && <Txt textStyle="bold" color='brand.500'>{selectedFile.name}</Txt>} 
    <input
      ref={inputRef}
      type='file'
      disabled={disabled}
      accept={accept}
      onChange={onFileChange}
    />
  </Box>;
};

const UploadWrapperStyles = {
  width: '100%',
  height: '100%',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  border: '1px dashed var(--chakra-colors-gray-500)',
  borderRadius: '8px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 'var(--chakra-space-2)',

  '& input': {
    opacity: 0,
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    cursor: 'pointer',
  }
};